function scaleHomepageHero() {
  let scaleAmount = 1.01;
  const heroImage = document.querySelector('[data-background-scaling] img');

  window.addEventListener('scroll', () => {
    if (!heroImage || window.innerWidth < 990) { return; }

    scaleAmount = ((window.scrollY + 350) / 350) - 0.25;

    if (scaleAmount < 1) {
      scaleAmount = 1;
    } else if (scaleAmount >= 1.5) {
      scaleAmount = 1.5;
    }

    heroImage.style.transform = `scale(${scaleAmount})`;
  });
}

  // Open external links in new tab
function openExternalLinksInNewTab() {
  var links = document.links;

  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }
}

function videoPopups() {
  const videoPopupTriggers = document.querySelectorAll('[data-video-popup-trigger]');
  const videoPopupWrappers = document.querySelectorAll('[data-video-popup-wrapper]');

  if (videoPopupTriggers) {
    videoPopupWrappers.forEach((videoPopupWrapper) => {
      const newPopup = document.createElement('div');

      newPopup.innerHTML = videoPopupWrapper.innerHTML;

      document.body.appendChild(newPopup);

      videoPopupWrapper.remove();
    });

    videoPopupTriggers.forEach((videoPopupTrigger) => {
      videoPopupTrigger.addEventListener('click', () => {
        const triggerId = videoPopupTrigger.getAttribute('data-id');
        const videoPopups = document.querySelectorAll('[data-video-popup]');

        videoPopups.forEach((videoPopup) => {
          const popupId = videoPopup.getAttribute('data-id');
          const popupIframe = videoPopup.querySelector('iframe');
          const popupVideo = videoPopup.querySelector('video');

          if (triggerId !== popupId) { return; }

          if (popupIframe) {
            const originalSrc = popupIframe.getAttribute('data-original-src');
            popupIframe.setAttribute('src', `${originalSrc}?autoplay=1`);
          } else {
            popupVideo.play();
          }

          videoPopup.classList.remove('hidden');
          document.body.classList.add('overflow-hidden');
        });
      });
    });

    document.addEventListener('click', (event) => {
      if (!event.target.hasAttribute('data-video-popup-close')) { return; }
      closeVideoPopups();
    });

    document.addEventListener('keyup', (event) => {
      if (event.key !== 'Escape') { return; }
      closeVideoPopups();
    });

    function closeVideoPopups() {
      document.body.classList.remove('overflow-hidden');
      const videoPopups = document.querySelectorAll('[data-video-popup]');

      videoPopups.forEach((videoPopup) => {
        const popupIframe = videoPopup.querySelector('iframe');
        const popupVideo = videoPopup.querySelector('video');

        if (popupIframe) {
          const originalSrc = popupIframe.getAttribute('data-original-src');
          popupIframe.setAttribute('src', `${originalSrc}`);
        } else {
          popupVideo.pause();
        }

        videoPopup.classList.add('hidden');
      });
    }
  }
}

function mobileNavLinks() {
  const mobileNavLinks = document.querySelectorAll('[data-mobile-nav-link]');
  const mobileNavClose = document.querySelector('[data-mobile-nav-close]');

  if (!mobileNavLinks.length) { return; }

  mobileNavLinks.forEach((mobileNavLink) => {
    mobileNavLink.addEventListener('click', () => {
      if (mobileNavLink.getAttribute('href').indexOf('#featured-product') === -1) { return; }

      mobileNavClose.click();
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  AOS.init({
    once: true
  });

  scaleHomepageHero();
  openExternalLinksInNewTab();
  videoPopups();
  mobileNavLinks();
});

function updateShopPayIconColor() {
  const shopifyPaymentTerms = document.querySelector('shopify-payment-terms');
  
  if (!shopifyPaymentTerms) { return; }

  const shopPayLogo = shopifyPaymentTerms.shadowRoot.querySelector('shop-pay-logo');
  const style = document.createElement('style');
  
  style.innerHTML = '.shop-pay-logo path { fill: rgba(var(--color-scheme-text),var(--tw-text-opacity)); }';
  shopPayLogo.shadowRoot.appendChild(style);
}

window.addEventListener('load', () => {
  updateShopPayIconColor();
});
